module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"notice_title":"[{brand_name} 적립금 안내]","new_review_button_label_with_mileage":"리뷰 작성하고 최대 %{expected_mileage}원 받기","new_review_button_label":"리뷰 작성하기","max_mileage":"최대 {0} 적립 가능","no_review_message":"작성할 리뷰가 없습니다.","money":"원"}}')
  delete Component.options._Ctor
}
